import BaseModel from './base';
import HallExposition from './exhibition-hall-exposition';
import { HALL_TYPE, HALL_UPLOAD_GRAND } from '@/modules/EventExhibition/constants';
import HallSettings from './exhibition-hall-settings';
import Exhibition from './exhibition';
import User from '@/utils/user.js';
import ExhibitionTag from './exhibition-tag';

export default class Hall extends BaseModel {
  #user;

  constructor(item, url) {
    super(item, url);
    this.description = item.description || '';
    this.decoration_type = item.decoration_type || HALL_TYPE.first;
    this.exhibition_id = item.exhibition_id;
    this.settings = item.settings ? new HallSettings(item.settings) : null;

    this.tags = (item.tags || []).map((tag) => new ExhibitionTag(tag));

    this.exhibition = item.exhibition ? new Exhibition(item.exhibition, 'exhibitions') : null;

    this.expositions = (item.expositions || [])
      .map((exposition) => new HallExposition(exposition, 'exhibition-expositions'));

    this.#user = new User();
  }

  get owner_id() {
    const { owner_id } = this.exhibition || {};
    return owner_id || null;
  }

  get isOwner() {
    return this.#user.data?.id === this.owner_id;
  }

  get canCreateExposition() {
    if (this.isOwner) return true;
    if (!this.settings) return false;
    const { upload_grant } = this.settings;
    switch (upload_grant) {
      case HALL_UPLOAD_GRAND.organizations: return this.#user.isOrganization;
      case HALL_UPLOAD_GRAND.members: return this.#user.isMember;
      case HALL_UPLOAD_GRAND.everyone: return this.#user.isAuthenticated;
      case HALL_UPLOAD_GRAND.me:
      default: return this.isOwner;
    }
  }
}
